export const REDUCER_NAME = "inventoryProductsFilter";

export const ACTION_TYPES = {
  setFilter: `${REDUCER_NAME}/setFilter`,
  removeFilter: `${REDUCER_NAME}/removeFilter`,
};
